<template>
    <section class="viewsrhwxControl_AppointRecord" @scroll="handleScroll($event)">
        <section class="headerTabsClass">
            <div class="headerTabsItemClass">
                <el-radio-group v-model="params.radioTime" fill="#009967" size="small" style="width: 100%;"
                    @change="radioChange">
                    <el-radio-button label="昨天"></el-radio-button>
                    <el-radio-button label="今天"></el-radio-button>
                    <el-radio-button label="明天"></el-radio-button>
                </el-radio-group>
            </div>
            <div class="headerTabsItemClass" style="width: calc(100% - 186px);margin-left: 5px;">
                <el-input @click.native="visible = true" suffix-icon="el-icon-date" size="small" v-model="params.timeValue"
                    placeholder="请选择日期" readonly style="width: calc(100% - 10px);"></el-input>
            </div>
        </section>
        <section>
            <div class="cont3">
                <div @click="toDetail(item)" class="defaultBg mgBottom10" style="display: flex;" v-for="(item, index) in records" :key="index">
                    <div class="cont3-left">
                        <!-- <div class="top greyBg">FP024</div> -->
                        <div style="padding: 10px;">
                            <span class="left1">{{ item.short_name }}</span>
                        </div>
                        <van-row>
                            <van-col class="car_list_item" span="6">
                                <span>计划车辆</span>
                                <label :style="{ color: 'red' }">{{ item.plan_num }}</label>
                            </van-col>
                            <van-col class="car_list_item" span="6">
                                <span>预约车辆</span>
                                <label :style="{ color: 'red' }">{{ item.booking_num }}</label>
                            </van-col>
                            <van-col class="car_list_item" span="6">
                                <span>有效车辆</span>
                                <label>{{ item.valid_num }}</label>
                            </van-col>
                            <van-col class="car_list_item" span="6">
                                <span>无效车辆</span>
                                <label>{{ item.close_num }}</label>
                            </van-col>
                        </van-row>
                    </div>
                </div>
            </div>
        </section>
        <template v-if="params.last_page > 0">
            <van-divider v-if="(params.page == params.last_page)">没有更多了~</van-divider>
        </template>
        <van-calendar ref="calendar" :default-date="params.time" color="#009967" v-model="visible" type="range"
                @confirm="onDateConfirm" 
                :formatter="formatter"
                :min-date="minDate"
                :max-date="maxDate"
            >
            <template #footer>
                <div class="calendar-btn-group">
                    <van-button @click="targetReset" block color="#aaaaaa">重置</van-button>
                    <van-button @click="targetConfirm" block color="#009967">确定</van-button>
                </div>
            </template>
        </van-calendar>
    </section>
</template>

<script>
import moment from "moment";
import socketListComputedMixin from "@/mixins/rh/socketListComputedMixin.js";
export default {
    props: [""],

    data() {
        return {
            params: {
                time: [],
                begin_time: '',
                end_time: '',
                radioTime: '今天',
                timeValue: '',
                page: 1,
                page_size: 15,
                booking_state: 0,
                last_page: 0,
            },
            visible: false,
            minDate: new Date(moment().year() - 5, 0, 1),
            maxDate: new Date(moment().year() + 10, 0, 1),
            records: [],
            stateOption: [
                "全部",
                "未报到",
                "已报到",
                "报到失效",
                "办理中",
                "已挂起",
                "已失效",
                "已关闭",
                "已完成"
            ],
            stateColor: [
                "",
                "#B08931",
                "#00C8D2",
                "#666666",
                "#4F86F6",
                "#F5A623",
                "#666666",
                "#EC3F67",
                "#008B5E"
                // "#EC3F67"
            ],
        };
    },

    computed: {},

    watch: {},

    components: {},

    mixins: [socketListComputedMixin],

    beforeCreate() { },

    created() {
        this.radioChange('今天');
    },

    beforeMount() { },

    mounted() {},

    activated() { },

    destroyed() {},

    deactivated() { },

    methods: {
        // 格式化日历显示
        formatter(day) {
            if (day.type === "start") {
                day.bottomInfo = "";
            } else if (day.type === "end") {
                day.bottomInfo = "";
            } else {
                day.bottomInfo = "";
            }
            return day;
        },
        toDetail(item) {
            this.$router.push({
                path: '/rhwxAppointDetail',
                query: {
                    info_id: item.booking_info_id,
                    id: item.booking_id,
                    pageType: 'list',
                    time1: this.params.begin_time,
                    time2: this.params.end_time,
                    keyword: '',
                    readonly: 1
                }
          })
        },
        targetReset() {
            this.$refs.calendar.reset();
            this.params.page = 1;
            this.params.time = [];
            this.params.begin_time = "";
            this.params.end_time = "";
            this.params.timeValue = "";
            this.params.radioTime = "";
            this.records = [];
            this.getList();
            this.visible = false;
        },
        targetConfirm() {
            this.$refs.calendar.onConfirm();
        },
        async getList() {
            let dataObj = await this.$common.http({
                url: '/api/queue/admin/list_booking_plan',
                data: {
                    unit_name: '',
                    begin_date: this.params.begin_time,
                    end_date: this.params.end_time,
                    page: this.params.page,
                    page_size: this.params.page_size
                }
            });
            this.params.last_page = dataObj.data.data.last_page;
            this.records = [...this.records, ...dataObj.data.data.data];
        },
        // 滚动触底
        handleScroll(e) {
            if (e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight) {
                //在此处放入你的加载更多方法
                console.log('触底');
                if (this.params.page == this.params.last_page) {
                    return;
                }
                this.params.page += 1;
                this.getList();
            }
        },
        // 点击radio(切换时间)
        radioChange(val) {
            this.params.page = 1;
            this.params.time = [];
            this.params.timeValue = "";
            this.records = [];
            switch (val) {
                case "昨天":
                    this.params.begin_time = moment()
                        .subtract(1, "days")
                        .format("YYYYMMDD");
                    this.params.end_time = moment()
                        .subtract(1, "days")
                        .format("YYYYMMDD");
                    break;
                case "今天":
                    this.params.begin_time = moment().startOf("day").format("YYYYMMDD");
                    this.params.end_time = moment().startOf("day").format("YYYYMMDD");
                    break;
                case "明天":
                    this.params.begin_time = moment().add(1, "days").format("YYYYMMDD");
                    this.params.end_time = moment().add(1, "days").format("YYYYMMDD");
                    break;
                default:
                    break;
            }
            this.getList();
        },
        onDateConfirm(e) {
            this.time = e;
            this.params.begin_time = moment(e[0]).format("YYYYMMDD");
            this.params.end_time = moment(e[1]).format("YYYYMMDD");
            this.params.timeValue = moment(e[0]).format("YYYY/MM/DD") + '~' + moment(e[1]).format("YYYY/MM/DD");
            this.params.page = 1;
            this.params.radioTime = "";
            this.records = [];
            this.getList();
            this.visible = false;
        }
    },
};
</script>
<style lang='less' scoped>
.viewsrhwxControl_AppointRecord {
    padding: 10px 0 0 0;
    background-color: #f4f5f6;
    height: 100vh;
    overflow: auto;
    box-sizing: border-box;

    .car_list_item {
        text-align: center;
        span {
            display: block;
        }
        label {
            font-size: 24px;
            line-height: 2;
        }
    }

    .calendar-btn-group {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50px;
        overflow: hidden;
    }

    .defaultBg {
        background-image: linear-gradient(270deg, #fff, #f8f8f8, #f4f5f6);
    }

    .mgBottom10 {
        margin-bottom: 10px;
    }

    .headerTabsClass {
        display: flex;
        align-items: center;
        justify-content: center;

        .headerTabsItemClass {
            text-align: center;
        }
    }

    .cont3 {
    background: #fff;
    padding: 16px;
    margin: 10px 0px 10px;
    &-title {
      font-size: 18px;
      padding-bottom: 14px;
    }
    &-left {
      font-size: 14px;
      line-height: 22px;
      padding: 0px 0px 7px;
      flex: 2;
      color: #4f4a4c;
      .top {
        background: #00c8d2;
        box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
        border-radius: 4px 0 13px 0;
        width: 55px;
        text-align: center;
        color: white;
        font-size: 18px;
        margin-bottom: 5px;
      }
      .left1 {
        line-height: 26px;
        font-size: 18px;
        color: #000;
      }
      .left2 {
        float: right;
        margin-top: 2px;
      }
      .left5 {
        float: right;
      }
    }
    &-right {
      flex: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      flex-flow: wrap;
      padding: 21px 0px;
      & > div {
        flex: 1;
        text-align: right;
      }
    }
  }
}
</style>
<style lang='less'>
.viewsrhwxControl_AppointRecord {}
</style>